import React from "react";
import { X } from "lucide-react";
import Drawer from "./Drawer";
import EmailFollowUpAdminMonitor from "../organisms/EmailFollowUpAdminMonitor";

export default function EmailFollowUpAdminDrawer({ open, onClose }) {
  return (
    <Drawer open={open} onClose={onClose} width="min(920px, 92vw)">
      <div style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0, position: "relative" }}>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute", top: 14, right: 14, zIndex: 2,
            width: 32, height: 32, borderRadius: 8, border: "1px solid var(--color-border-subtle)",
            background: "var(--color-bg-surface)", cursor: "pointer",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <X size={16} />
        </button>
        <EmailFollowUpAdminMonitor />
      </div>
    </Drawer>
  );
}
